module.exports = __webpack_public_path__ + "static/assets/00e32229be29e3e724aee1eb987bed2b.svg";